import { GetterTree } from "vuex";
import { TerratalkLiveGetters, TerratalkLiveGetterNames, S, R } from "./types";

export const terratalkLiveGetters: GetterTree<S, R> & TerratalkLiveGetters = {
  [TerratalkLiveGetterNames.ACTIVE_SESSION]: (state, getters) => {
    const sessions = Object.values(state.sessions || {});
    const activeSession = getters[`${TerratalkLiveGetterNames.ACTIVE_SESSION_DETAILS}`];

    return sessions?.filter(session => {
      return session?.id === activeSession?.id;
    })?.[0];
  },

  [TerratalkLiveGetterNames.ACTIVE_SESSION_DETAILS]: state => {
    // this state.sessions is used to make sure this getter is re-evaluated any time the sessions are updated
    state.sessions;
    const sessionDetails = Object.values(state.sessionDetails || {});

    return sessionDetails?.find(sessionDetails => {
      const startTime = Date.parse(sessionDetails.startsAt);
      const now = Date.now();

      return startTime < now;
    });
  },

  [TerratalkLiveGetterNames.LIMITED_MODE_DETAILS]: state => {
    return state.limitedModeDetails;
  },

  [TerratalkLiveGetterNames.LIMITED_MODE_EXERCISES]: state => {
    return state.limitedModeDetails?.exercises;
  },

  [TerratalkLiveGetterNames.LIVE_STATE]: state => {
    return state.liveState;
  },

  [TerratalkLiveGetterNames.SESSIONS]: state => {
    return state.sessions;
  },

  [TerratalkLiveGetterNames.SESSION_DETAILS]: state => {
    return state.sessionDetails;
  },

  [TerratalkLiveGetterNames.UPCOMING_SESSIONS]: state => {
    return state.liveState?.sessions;
  }
};
